var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-col',{attrs:{"col":"12"}},[_c('div',{staticClass:"elfsight-app-76784924-6152-433d-968f-89e6afae1c33"})])}
var staticRenderFns = []

export { render, staticRenderFns }